import { Button, Surface } from '@vst/beam';
import { useTranslation } from 'react-i18next';

import { SpinnerButton } from '@app/components/SpinnerButton';
import { useScreenResolution } from '@app/hooks';

import styles from './styles.module.scss';

type WifiFooterProps = {
  loading: boolean;
  onSave: () => void;
  onCancel?: () => void;
  disabled?: boolean;
};

const WifiFooter = ({ onCancel, disabled, onSave, loading }: WifiFooterProps): JSX.Element => {
  const { t } = useTranslation('Network');
  const { isExtraSmall, isSmall } = useScreenResolution();
  const isMobile = isExtraSmall || isSmall;

  return (
    <Surface pt={'24px'} className={styles['wifiFooter']}>
      <Button
        onClick={(e) => {
          e.preventDefault();
          onCancel?.();
        }}
        variant="tertiary"
      >
        {t('networkManagement.cancelButton')}
      </Button>

      <SpinnerButton
        fluid={isMobile}
        type={'submit'}
        variant={'primary'}
        loading={loading}
        disabled={disabled}
        handleClick={onSave}
        label={t('networkManagement.saveInfoButton')}
      />
    </Surface>
  );
};
export default WifiFooter;
